import React, { useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import * as S from './pix-payment.page.style';
import { Sell } from '../../../common/types/venda';

type Props = {
  pix: Sell;
  onCopy: () => void;
  showTooltip: boolean;
  timer: string;
};

export const PixPaymentPage: React.FC<Props> = ({
  pix,
  onCopy,
  showTooltip,
  timer,
}) => {
  const [windowDimensions, setWindowDimensions] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });
  const [showConfetti, setShowConfetti] = useState(true);
  const [confettiOpacity, setConfettiOpacity] = useState(1);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    setWindowDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });

    window.addEventListener('resize', handleResize);
    
    const fadeOutTimer = setTimeout(() => {
      setConfettiOpacity(0);
    }, 5000);

    const hideTimer = setTimeout(() => {
      setShowConfetti(false);
    }, 5500);

    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(fadeOutTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  return (
    <S.Container>
      {showConfetti && windowDimensions.width > 0 && windowDimensions.height > 0 && (
        <div style={{ opacity: confettiOpacity, transition: 'opacity 0.5s ease-out', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 9999 }}>
          <Confetti
            width={windowDimensions.width}
            height={windowDimensions.height}
            recycle={false}
            numberOfPieces={250}
            gravity={0.25}
            wind={0.03}
            initialVelocityY={15}
            initialVelocityX={5}
            colors={['#FFD700', '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE']}
          />
        </div>
      )}
      <S.ContentWrapper>
        <S.PixSuccessTitle>PIX gerado com sucesso!</S.PixSuccessTitle>
        <S.PixSuccessSubtitle>
          Agora é só finalizar o pagamento
        </S.PixSuccessSubtitle>

        <S.PixTimerRow>
          <span>Tempo restante para pagamento:</span>
          <S.PixTimerDisplay>{timer}</S.PixTimerDisplay>
        </S.PixTimerRow>

        <S.PixCard>
          <S.PixStatusHeader>
            <S.LoadingSpinner />
            <S.PixStatusText>Aguardando pagamento...</S.PixStatusText>
          </S.PixStatusHeader>

          <S.QRCodeContainer>
            <S.QRCodePlaceholder>
              <S.QRCode
                src={`data:image/png;base64, ${pix?.pixQrCode}`}
                alt="QR Code"
              />
            </S.QRCodePlaceholder>
          </S.QRCodeContainer>

          <S.ApprovalTime>
            <S.ApprovalIcon>✓</S.ApprovalIcon>
            <span>A aprovação leva no máximo 1 minuto</span>
          </S.ApprovalTime>

          <S.PixButtonsContainer>
            <S.PixCompactButton onClick={onCopy}>
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
              </svg>
              Copiar código Pix
            </S.PixCompactButton>
            {/*<S.PixPrimaryButton
              onClick={() => alert('Aguarde a confirmação do pagamento...')}
            >
              Já fiz o pagamento
            </S.PixPrimaryButton>*/}
          </S.PixButtonsContainer>

          <S.PixInstructions>
            <S.InstructionsTitle>Como pagar com PIX:</S.InstructionsTitle>
            <S.InstructionsList>
              <S.InstructionItem>1. Abra o app do seu banco</S.InstructionItem>
              <S.InstructionItem>2. Entre na opção PIX</S.InstructionItem>
              <S.InstructionItem>
                3. Escolha pagar com QR Code ou Pix Copia e Cola
              </S.InstructionItem>
              <S.InstructionItem>
                4. Escaneie o código acima ou cole o código copiado
              </S.InstructionItem>
              <S.InstructionItem>
                5. Confirme o pagamento no seu banco
              </S.InstructionItem>
            </S.InstructionsList>
          </S.PixInstructions>

          <S.PixCodeBox onClick={onCopy}>
            <S.PixCodeLabel>Código PIX (Copia e Cola):</S.PixCodeLabel>
            <S.PixCodeText>{pix?.pixCopiaCola}</S.PixCodeText>
          </S.PixCodeBox>
        </S.PixCard>
      </S.ContentWrapper>
    </S.Container>
  );
};
